<app-page-dialog>
    <div dialogTitle class="d-flex" style="gap: 16px;">
        <div class="icon-circle d-flex align-items-center justify-content-center ">
            <mat-icon style="margin-bottom: 5px; color: #EA7D1D;">warning</mat-icon>
        </div>
        <div>Alerta de seguretat</div>
    </div>
    <div dialogHeader class="eac-c1" style="padding-left: 64px; position: relative; top: -24px;">
        No tens permisos per realitzar aquesta acció. Truca al teu administrador perquè te'n doni.
    </div>
    <div dialogFooter class="d-flex" style="padding-top: 24px;">
        <div style="flex: 1 0 0;"></div>
        <button mat-flat-button color="primary" (click)="close()" style="padding: 20px;">
            Entés
        </button>
    </div>
</app-page-dialog>
